/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Der Schritt im Antrag, auf dem zwischengespeichert wurde. Nur beim Speichern aus dem Antrag gesetzt; der Link öffnet den Antrag wieder auf diesem Schritt.
 */
export enum AntragSchritt {

    Fragen = 'Fragen',

    Zusammenfassung = 'Zusammenfassung'
}

